jQuery(function () {
  if ($("input[name='owner[payment_type_id]']:checked").val() == 2) {
    document.getElementById('invoice_send_type').style.display = "block";
    document.getElementById('info_payment_by_bill').style.display = "block";
    document.getElementById('description-payment').style.display = "none";
    document.getElementById('description-payment-transfer').style.display = "none";
    $("#lb-payment-name").text('請求書受け取り先名（会社名）');
    $("#ip-payment-name").attr('placeholder', '請求書受け取り先名（会社名）');
  } else if ($("input[name='owner[payment_type_id]']:checked").val() == 1) {
    $("#lb-payment-name").text('法人名');
    $("#ip-payment-name").attr('placeholder', '法人名');
    document.getElementById('invoice_send_type').style.display = "none";
    document.getElementById('info_payment_by_bill').style.display = "none";
    document.getElementById('description-payment').style.display = "block";
    document.getElementById('description-payment-transfer').style.display = "none";
  } else if ($("input[name='owner[payment_type_id]']:checked").val() == 3) {
    document.getElementById('invoice_send_type').style.display = "block";
    document.getElementById('info_payment_by_bill').style.display = "block";
    document.getElementById('description-payment').style.display = "none";
    document.getElementById('description-payment-transfer').style.display = "block";
    $("#lb-payment-name").text('請求書受け取り先名（会社名）');
    $("#ip-payment-name").attr('placeholder', '請求書受け取り先名（会社名）');
  } else {
    document.getElementById('invoice_send_type').style.display = "none";
    document.getElementById('info_payment_by_bill').style.display = "none";
    document.getElementById('description-payment').style.display = "none";
    document.getElementById('description-payment-transfer').style.display = "none";
  }

  if ($("input[name='owner[payment_attributes][use_owner_info]']:checked").val() == 'true') {
    document.getElementById('user_owner_info').style.display = "block";
  }
  $(".payment_type").change(function(e) {
    if ($(this).closest('.field_with_errors')[0] != undefined) {
      $(this).unwrap()
    }
    if( $(this).val() == 1){
      $("#lb-payment-name").text('法人名');
      $("#ip-payment-name").attr('placeholder', '法人名');
      document.getElementById('invoice_send_type').style.display = "none";
      document.getElementById('description-payment').style.display = "block";
      document.getElementById('info_payment_by_bill').style.display = "none";
      document.getElementById('description-payment-transfer').style.display = "none";
    }
    else if( $(this).val() == 2) {
      $("#lb-payment-name").text('請求書受け取り先名（会社名）');
      $("#ip-payment-name").attr('placeholder', '請求書受け取り先名（会社名）');
      document.getElementById('invoice_send_type').style.display = "block";
      document.getElementById('description-payment').style.display = "none";
      document.getElementById('info_payment_by_bill').style.display = "block";
      document.getElementById('description-payment-transfer').style.display = "none";
    }
    else {
      $("#lb-payment-name").text('請求書受け取り先名（会社名）');
      $("#ip-payment-name").attr('placeholder', '請求書受け取り先名（会社名）');
      document.getElementById('invoice_send_type').style.display = "block";
      document.getElementById('description-payment').style.display = "none";
      document.getElementById('info_payment_by_bill').style.display = "block";
      document.getElementById('description-payment-transfer').style.display = "block";
    }
  });
  $(".user_owner_info").change(function(e) {
    if ($(this).closest('.field_with_errors')[0] != undefined) {
      $(this).unwrap()
    }
    if($(this).val() == 'true'){
      $('#owner_payment_attributes_name').val('');
      $('#owner_payment_attributes_staff_name').val('');
      $('#owner_payment_attributes_staff_name_kana').val('');
      $('#owner_payment_attributes_department_name').val('');
      $('#owner_payment_attributes_postcode').val('');
      $('#owner_payment_attributes_prefecture_id').val('');
      $('#owner_payment_attributes_city').val('');
      $('#owner_payment_attributes_address').val('');
      $('#owner_payment_attributes_building_name').val('');
      $('#owner_payment_attributes_email').val('');
      $('#owner_payment_attributes_building_name').val('');
      $('owner_payment_attributes_phone').val('');
      document.getElementById('user_owner_info').style.display = "block";
    }
    else {
      document.getElementById('user_owner_info').style.display = "none";
    }
  });
});
$('form').on('keypress', e => {
  if (e.keyCode == 13) {
      return false;
  }
});